import React, { useState } from "react";
import { notifyError, notifySuccess } from "../../../helper";
import client from "../../../api";

const EditLabelModelWindow = (props) => {
    const api = client();
    const [loading,setLoading] = useState(false);
    const [updatedLabel, setUpdatedLabel] = useState(props.selectedLabel);
    const [error, setError] = useState('');
    const handleUpdateLabel = async () => {
        if(updatedLabel.label_name === ''){
            setError('Label Name can not empty');
        } else {
            try{
                setLoading(true);
                const payload = {
                    label_id: updatedLabel._id ,
                    label_name: updatedLabel.label_name
                }
                const response = await api.post("/v1/label/update",payload);
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Label updated sucessfully');
                    setTimeout(()=>{
                        window.location.reload();
                        props.setToggleEditModelWindow(false);
                    },1500);
                }
            } catch (error){
                console.log("error.message",error);
                setLoading(false);
                if(error.status === 400){
                    notifyError('Bad Request. Unable to update the label. Please try again.');
                }
            } finally{
                setLoading(false);
            }
        }
    }
    const inputFieldChange = (e) => {
        setUpdatedLabel({...updatedLabel,label_name:e.target.value});
    }

    const onBlur = () => {
        if(updatedLabel.label_name === ''){
            setError('Label Name can not empty');
        }
    }

    const onFocus = () => {
        setError('');        
    }

    console.log('updatedLabel',updatedLabel);
    return(<>
        <div className="model-window">
        <div className="overlay"></div>
        <div className="model-view">
            <div className="inner-view">
                <h2>Update Label</h2>
                <p>The following Label will be updated. The label list will be updated for its use.</p>
                <div className="field-wrap">
                    <label className="label-xs">Label Name:</label>
                    <input 
                        type="text" 
                        value={updatedLabel?.label_name} 
                        onChange={inputFieldChange} 
                        onBlur={onBlur}
                        onFocus={onFocus}
                        />
                        {error.length ? <span className="validation-error">{error}</span>:''}
                </div>
                <div className="button-group">
                    <button 
                        type="button" 
                        className={loading ? "delete-btn button--loading":"delete-btn"} 
                        disabled={loading}
                        onClick={()=>handleUpdateLabel()}>
                            <span className="button--text">Update</span>
                    </button>                        
                    <button className="cancel-btn" onClick={()=>props.setToggleEditModelWindow(!props.toggleEditModelWindow)}>Cancel</button>
                </div>
            </div>
        </div>
    </div>
    </>);
}
export default EditLabelModelWindow;